import React from "react";
import { resetFreshman } from "helpers/freshman";
import tutorials from "images/tutorials.png";
import devicesHelp from "images/devicesHelp.png";
import howEfficeWorks from "images/howEfficeWorks.png";

const HelpModalBody = ({ onDismiss }) => {
  return (
    <>
      <div className="help-modal-section">
        <div>
          <button
            onClick={() => {
              resetFreshman();
              onDismiss();
            }}
            className="helper-button "
          >
            Turn on <br />
            Tutorials
          </button>
        </div>
        <div>
          <img src={tutorials} alt="tutorials" />
        </div>
      </div>

      <div className="help-modal-section">
        <div>
          <a
            href={"https://efficespace.com/devices-help/"}
            target={"_blank"}
            rel={"noreferrer"}
            className="helper-button "
          >
            Get Help Connecting Your Device
          </a>
        </div>
        <div>
          <img src={devicesHelp} alt="devices help" />
        </div>
      </div>
      <div className="help-modal-section">
        <div>
          <a
            href={"https://efficespace.com/learn-more/"}
            target={"_blank"}
            rel={"noreferrer"}
            className="helper-button "
          >
            Learn How EfficeSpace Works
          </a>
        </div>
        <div>
          <img src={howEfficeWorks} alt="how effice works" />
        </div>
      </div>
    </>
  );
};

export default HelpModalBody;
